module.exports = __webpack_public_path__ + "img/heavy-rain-button.d1cdf932.svg";